/**
 * Telemetry configuration for E2E testing.
 *
 * Centralized config for test reporting, model restrictions, and feature flags.
 */

export const TELEMETRY_CONFIG = {
  /**
   * Backend endpoint for test reports.
   */
  endpoint: "/v1/ai/test/report",

  /**
   * Model restriction for testing (e.g. for assertions in E2E).
   */
  testModelName: "gpt-4o-mini",

  /**
   * Enable telemetry globally.
   * Set to false to disable all test reporting.
   */
  enabled: true,

  /**
   * Enable feedback loop (self-optimization).
   * Currently deferred - backend only receives and stores data.
   */
  enableFeedbackLoop: false,

  /**
   * Screenshot settings.
   */
  screenshot: {
    enabled: true,
    mimeType: "image/png" as const,
    exportPadding: 20,
  },
} as const;
